// @flow

import * as React from 'react';

import type { PreviewVenue } from './types';

type Props = {|
  venue: PreviewVenue,
  className?: string,
  children: React.Node,
  onClickVenueLink?: () => void,
  openInNewTab: boolean
|};

export default function VenueLink(props: Props) {
  const { openInNewTab, venue, className } = props;
  const linkTarget = openInNewTab ? `venue_${venue.id}` : '_self';

  return (
    <a
      onClick={props.onClickVenueLink}
      href={venue.url}
      target={linkTarget}
      className={className}
    >
      {props.children}
    </a>
  );
}
